import React, { useEffect } from 'react'
import { FormControl, InputLabel, Select, MenuItem  } from '@mui/material'
import { useParams } from 'react-router-dom'

function EventSelect({eventList, setEvent, selectedRegion, selectedContest}) {

    const {prov, year} = useParams()
    useEffect(()=> {
        if (selectedRegion&&eventList) {
            if (selectedRegion === 'Toronto') {
                let eventfilter = eventList.contests.find(event=>event.area.name === 'Toronto' && event.office.name === "Mayor")
                if (eventfilter) {
                    setEvent(eventfilter.id)
                }
            }
        }
    }, [selectedRegion])

    const handleChange = (e) => {
        setEvent(e.target.value)
    }

    return (
        <FormControl id="widget-selectBox" variant="standard" style={{maxWidth: '600px', width: '80%'}}>
            <InputLabel>Select election event</InputLabel>
            <Select value={selectedContest}  onChange={handleChange}>
                {eventList && eventList.contests.length > 1 && <MenuItem key={'all'} default value={''} >All</MenuItem>}
                {eventList && eventList.contests.filter(a=>{
                    if (selectedRegion === 'Montréal') {
                        console.log('true')
                    }
                    return true
                })
                .sort((a, b) => 
                    // if (a.area.name === "Toronto"){return -1}
                    // else if(a.office.name === "Mayor"){return -1}
                   ["Toronto"].includes(b.area.name) - ["Toronto"].includes(a.area.name) || (["Mayor"].includes(b.office.name) - ["Mayor"].includes(a.office.name) || a.area.name.localeCompare(b.area.name, 'en', { numeric: true, sensitivity: 'base' }))
                )
                .map((event, i)=>{
                    let eventString = `${event.area.name} - ${event.office.name}`
                    if (year === '2023' && prov === 'on') {
                        
                        eventString = `${event.area.name}`
                    }
                    return (
                        <MenuItem key={`event-${i}`} style={{whiteSpace: 'unset', wordBreak: 'break-word'}} value={event.id}>{eventString}</MenuItem>
                    )
                })}
            </Select>
        </FormControl>
    )
}
    

export default EventSelect
